import cx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';

import styles from './JackpotBetWidget.module.scss';

export interface AnimatedDigitPropTypes {
  value: string;
  isDecimalValue?: boolean;
}

const AnimatedDigit = ({
  value,
  isDecimalValue = false,
}: AnimatedDigitPropTypes) => {
  const isInitial = useRef(true);
  const [currentDigit, setCurrentDigit] = useState(value);
  const [valueChanged, setValueChanged] = useState(false);

  useEffect(() => {
    if (isInitial.current) {
      isInitial.current = false;
      return;
    }

    setValueChanged(true);

    setTimeout(() => {
      setValueChanged(false);
      setCurrentDigit(value);
    }, 400);
  }, [value]);

  return (
    <>
      {valueChanged ? (
        <div
          className={cx(
            styles.badgeNewValueContainer,
            isDecimalValue && styles.badgeValueDecimal
          )}
        >
          <div className={styles.badgeNewValue}>{value}</div>
          <div className={styles.badgeOldValue}>{currentDigit}</div>
          <div className={styles.hiddenValue}>{value}</div>
        </div>
      ) : (
        <div className={cx(isDecimalValue && styles.badgeValueDecimal)}>
          {currentDigit}
        </div>
      )}
    </>
  );
};

export default AnimatedDigit;
